import { useEffect, useRef, useState, useCallback } from "react";
import classes from "./TextTruncate.module.scss";
export const ClampText = ({ text, lines = 3, children }) => {
  const ref = useRef(null);
  const [expanded, setExpanded] = useState(false);
  const [needsToggle, setNeedsToggle] = useState(false);

  const measure = useCallback(() => {
    const el = ref.current;
    if (!el) return;

    // Unclamp to measure full height
    el.style.setProperty("-webkit-line-clamp", "unset");
    el.style.overflow = "visible";

    const cs = getComputedStyle(el);
    const fontSize = parseFloat(cs.fontSize) || 16;
    let lineHeight = parseFloat(cs.lineHeight);
    if (Number.isNaN(lineHeight)) {
      // when line-height is 'normal', approximate (spec allows ~1.2)
      lineHeight = fontSize * 1.2;
    }

    // Force layout, then measure
    const fullHeight = el.scrollHeight;
    const totalLines = lineHeight ? Math.ceil(fullHeight / lineHeight) : 0;

    setNeedsToggle(totalLines > lines);

    // Restore clamp according to expanded state
    el.style.setProperty(
      "-webkit-line-clamp",
      expanded ? "unset" : String(lines)
    );
    el.style.overflow = expanded ? "visible" : "hidden";
  }, [lines, expanded]);

  useEffect(() => {
    measure();
  }, [measure, text, children]);

  useEffect(() => {
    const onResize = () => measure();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [measure]);

  return (
    <div className={classes.clamp_wrap}>
      <p
        ref={ref}
        className={`${classes.clamp_text} ${
          expanded ? classes.is_expanded : ""
        }`}
        style={!expanded ? { WebkitLineClamp: lines } : {}}
      >
        {children ?? text}
      </p>

      {needsToggle && (
        <button
          type="button"
          className={classes.clamp_toggle}
          onClick={() => setExpanded((v) => !v)}
        >
          {expanded ? "Read less" : "Read more"}
        </button>
      )}
    </div>
  );
};

export default ClampText;
